export default __webpack_public_path__ + "static/source-separation-systems-local-government-procurement-734efc97278d445ff51c2ce63eedb000.png";